import {createAction} from 'redux-actions';

import {
    getTimespanCategories,
    TimespanCategory,
    TimespanCategoryType,
} from '@pluto/rest';

import {CategoriesPayload} from './TimespanCategoriesTypes';

export const TIMESPAN_CATEGORY_SET = 'TIMESPAN_CATEGORY_SET';
export const TIMESPAN_CATEGORY_RESET = 'TIMESPAN_CATEGORY_RESET';
export const TIMESPAN_CATEGORIES_RESET = 'TIMESPAN_CATEGORIES_RESET';

export type SetCategories = (categories: TimespanCategory[]) => void;
export type ResetCategories = () => void;

export const setCategoryAction = createAction<Promise<CategoriesPayload>, TimespanCategoryType>(TIMESPAN_CATEGORY_SET, async (type: TimespanCategoryType): Promise<CategoriesPayload> => {
    try {
        const categories = await getTimespanCategories(type);
        
        return {
            type,
            categories,
        };
    } catch(error) {
        console.error(error);
        
        return {
            type,
            categories: [],
        };
    }
});

export const resetCategoryAction = createAction<TimespanCategoryType>(TIMESPAN_CATEGORIES_RESET);

export const resetCategoriesAction = createAction(TIMESPAN_CATEGORIES_RESET);
